import {
  addAnnouncement,
  removeAnnouncement,
  setAnnouncement,
} from "./announcementSlice";
import { removeAnnouncementFromLocalStorage } from "./helpers";
import {
  AnnouncementEventType,
  type AnnouncementItem,
  type SocketAnnouncementEvent,
} from "./types";

export const EXPERT_ANNOUNCEMENT_CHANNEL = "messaging/announcement/expert";

export const isAnnouncementActiveAt = (
  announcement: Pick<AnnouncementItem, "startAt" | "endAt">,
  now: Date,
) =>
  new Date(announcement.startAt).getTime() <= now.getTime() &&
  new Date(announcement.endAt).getTime() >= now.getTime();

export const getAnnouncementSocketAction = (
  event: SocketAnnouncementEvent<AnnouncementItem>,
  now: Date = new Date(),
) => {
  const announcement = event.payload.announcement;

  switch (event.type) {
    case AnnouncementEventType.ANNOUNCEMENT_CREATED:
      return addAnnouncement({
        ...announcement,
        active: isAnnouncementActiveAt(announcement, now),
      });
    case AnnouncementEventType.ANNOUNCEMENT_STARTED:
      return addAnnouncement({ ...announcement, active: true });
    case AnnouncementEventType.ANNOUNCEMENT_UPDATED: {
      removeAnnouncementFromLocalStorage(announcement.id);
      const updatedItem = {
        ...announcement,
        active: isAnnouncementActiveAt(announcement, now),
      };
      return setAnnouncement({
        id: updatedItem.id,
        changes: updatedItem,
      });
    }
    case AnnouncementEventType.ANNOUNCEMENT_DELETED:
      removeAnnouncementFromLocalStorage(announcement.id);
      return removeAnnouncement(announcement.id);
    case AnnouncementEventType.ANNOUNCEMENT_ENDED:
      removeAnnouncementFromLocalStorage(announcement.id);
      return setAnnouncement({
        id: announcement.id,
        changes: { ...announcement, active: false },
      });
    default:
      return undefined;
  }
};
